import { createErrorNotice, GENERIC_ERROR_MESSAGE } from "./notices"

type method = "GET" | "POST" | "PUT" | "DELETE"

export function post(uri: string, body: object): Promise<any> {
  return mutate("POST", uri, body)
}

export function put(uri: string, body: object): Promise<any> {
  return mutate("PUT", uri, body)
}

export function del(uri: string): Promise<any> {
  return mutate("DELETE", uri, {})
}

// Having a depency on createErrorNotice is a quick and dirty way to show errors on network errors.
//
// If we just throw an error here, it's considered unhadled unless each form does its own try/catch
// We should reconsider this later and see if there's a cleaner way of impleneting this.
async function mutate(method: method, uri: string, body: object) {
  let response
  let responseBody

  try {
    response = await fetch(uri, {
      method: method,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
      },
      mode: "same-origin",
      credentials: "same-origin",
      body: JSON.stringify(body),
    })

    responseBody = await response.json()

    if (!response.ok && responseBody?.errors?.toplevel) {
      createErrorNotice(responseBody.errors.toplevel)
    }
  } catch (_) {
    // We didn't get JSON or there is a network error
    createErrorNotice(GENERIC_ERROR_MESSAGE)
    return { ok: false, body: {} }
  }

  return { ok: response.ok, body: responseBody }
}
